export function addOccurrence(
  occurrences: Map<string, string[]>,
  name: string,
  fieldPath: string
): void {
  const paths = occurrences.get(name) ?? []
  paths.push(fieldPath)
  occurrences.set(name, paths)
}
